import { UserRoles } from '@modules/common'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'

export interface AttributeField {
  id?: string
  attributeId?: string
  cuid?: string
  type?: string
  showLabel?: boolean
  displayType?: string
  caseType?: string
  dummyValue?: string | number
  label?: string
  value?: string
  hasDoubleSpace?: boolean
  valueType?: string
}

export const CARD_PERMISSION_MAP = [
  {
    id: VIPChannel.Wholesale,
    permissions: [UserRoles.ADMINISTRATOR]
  },
  {
    id: VIPChannel.Retail,
    permissions: [UserRoles.ADMINISTRATOR]
  }
]

export const numberOfAttributes = {
  MAX: 6,
  MIN: 1
}

export const viewTabID = {
  collection: 'collection',
  wishlist: 'wishlist',
  orderCollection: 'orderCollection',
  addProductToOrder: 'addProductToOrder',
  lookbook: 'lookbook'
}

export const PRODUCT_DETAILS_TAB_NAMES = {
  overview: 'overview',
  moreAttributes: 'moreAttributes',
  orderQuantity: 'orderQuantity'
}

export const LIST_TABLE_TAB_NAMES = {
  quantity: 'quantity',
  summary: 'summary'
}

export const viewTabs = [
  {
    id: viewTabID.collection,
    name: 'Collection'
  },
  {
    id: viewTabID.wishlist,
    name: 'Wishlist'
  },
  {
    id: viewTabID.orderCollection,
    name: 'Order Collection'
  },
  {
    id: viewTabID.addProductToOrder,
    name: 'Add Products To Order'
  },
  {
    id: viewTabID.lookbook,
    name: 'LookBook'
  }
]

export const detailsViewTabs = [
  {
    id: viewTabID.collection,
    name: 'Collection'
  },
  {
    id: viewTabID.orderCollection,
    name: 'Order Collection'
  }
]

export const COMMON_DETAILS_TABS = [
  {
    id: PRODUCT_DETAILS_TAB_NAMES.overview,
    name: 'Overview'
  },
  {
    id: PRODUCT_DETAILS_TAB_NAMES.moreAttributes,
    name: 'More Attributes'
  }
]

export const ORDER_COLLECTION_DETAILS_TABS = [
  {
    id: PRODUCT_DETAILS_TAB_NAMES.orderQuantity,
    name: 'Order Quantity'
  }
]

export const LIST_TABLE_QUANTITY_TAB = [
  {
    id: LIST_TABLE_TAB_NAMES.quantity,
    name: 'Quantity',
    mappingId: 'listViewQuantity'
  }
]

export const LIST_TABLE_SUMMARY_TAB = [
  {
    id: LIST_TABLE_TAB_NAMES.summary,
    name: 'Summary',
    mappingId: 'listViewSummary'
  }
]

export const EXTRA_ATTRIBUTES_FOR_LIST_TABLE_COLUMNS = [
  {
    labelKey: 'bb.tableSetting.extraAttributes.rmClusters',
    id: 'rmClusters',
    displayName: 'RM Clusters'
  },
  {
    labelKey: 'bb.tableSetting.extraAttributes.cmClusters',
    id: 'cmClusters',
    displayName: 'CM Clusters'
  }
]
export const EXTRA_ATTRIBUTES_FOR_LIST_TABLE_ROWS = [
  {
    labelKey: 'bb.tableSetting.extraAttributes.clusterName',
    id: 'clusterName',
    displayName: 'Cluster Name'
  },
  {
    labelKey: 'bb.tableSetting.extraAttributes.totalBudgetValue',
    id: 'totalBudgetValue',
    displayName: 'Door OTB'
  },
  {
    labelKey: 'bb.tableSetting.extraAttributes.totalProducts',
    id: 'totalProducts',
    displayName: 'Number of ACs'
  },
  {
    labelKey: 'bb.tableSetting.extraAttributes.totalDoorQuantity',
    id: 'totalDoorQuantity',
    displayName: 'Door/Size Quantity'
  },
  {
    labelKey: 'bb.tableSetting.extraAttributes.totalDoorValue',
    id: 'totalDoorValue',
    displayName: 'Door/Size Value'
  }
]

export const EXCLUDED_VIEWS = {
  lookbook: viewTabID.lookbook
}

export const ORDER_PAGES_NAME = [
  'orderCollection',
  'addProductToOrder',
  'quantity',
  'summary'
]

export enum AttributeDisplayTypes {
  BOLD_TITLE_TEXT = 'BOLD_TITLE_TEXT',
  REGULAR_BODY_TEXT = 'REGULAR_BODY_TEXT',
  BOLD_TEXT = 'BOLD_TEXT',
  CHIP = 'CHIP'
}

export enum AttributeCaseTypes {
  UPPRECASE = 'UPPRECASE',
  LOWERCASE = 'LOWERCASE',
  TITLECASE = 'TITLECASE',
  NONE = 'NONE'
}

export const DEFAULT_DUMMY_VALUE = 'Sample value'

export const AttributeTypeHeight = {
  [AttributeDisplayTypes.BOLD_TITLE_TEXT]: 30,
  [AttributeDisplayTypes.REGULAR_BODY_TEXT]: 20,
  [AttributeDisplayTypes.BOLD_TEXT]: 20,
  [AttributeDisplayTypes.CHIP]: 30,
  LABEL_ITEM: 20,
  WITH_LABEL_PADDING: 10,
  WITHOUT_LABEL_PADDING: 5,
  EMPTY_VALUE: 10
}

export const ProductCardAttributeDisplayTypes = [
  {
    key: AttributeDisplayTypes.BOLD_TITLE_TEXT,
    labelKey: 'boldTitleText',
    name: 'Bold title text'
  },
  {
    key: AttributeDisplayTypes.REGULAR_BODY_TEXT,
    labelKey: 'regularBodyText',
    name: 'Regular body text'
  },
  {
    key: AttributeDisplayTypes.BOLD_TEXT,
    labelKey: 'boldText',
    name: 'Bold text'
  }
]
export const ProductCardAttributeCaseTypes = [
  {
    key: AttributeCaseTypes.UPPRECASE,
    labelKey: 'upperCase',
    name: 'Uppercase'
  },
  {
    key: AttributeCaseTypes.LOWERCASE,
    labelKey: 'lowerCase',
    name: 'Lowercase'
  },
  {
    key: AttributeCaseTypes.TITLECASE,
    labelKey: 'titleCase',
    name: 'Titlecase'
  },
  {
    key: AttributeCaseTypes.NONE,
    labelKey: 'none',
    name: 'None'
  }
]

export const chipAttributeDisplayType = {
  key: AttributeDisplayTypes.CHIP,
  labelKey: 'chip',
  name: 'Chip'
}

export const tableHeaders = {
  attribute: {
    key: 'attribute',
    label: 'Attribute'
  },
  showAttributeLabel: {
    key: 'showAttributeLabel',
    label: 'Show Label'
  },
  selectAttributeDiplayType: {
    key: 'selectAttributeDiplayType',
    label: 'Display type'
  },
  selectAttributeCaseType: {
    key: 'selectAttributeCaseType',
    label: 'Case type'
  },
  selectDoubleSpacing: {
    key: 'selectDoubleSpacing',
    label: 'Double Spacing'
  },
  enterDummyValue: {
    key: 'enterDummyValue',
    label: 'Dummy value'
  },
  preview: {
    key: 'preview',
    label: 'Preview - Medium Card'
  }
}

export const OrderQuantityViewOptions = [
  {
    id: 'horizontalView',
    title: 'Horizontal Quantity'
  },
  {
    id: 'verticalView',
    title: 'Vertical Quantity'
  }
]
